const CheckFill = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9994 19.7176C16.2599 19.7176 19.7137 16.2638 19.7137 12.0033C19.7137 7.74287 16.2599 4.28906 11.9994 4.28906C7.73896 4.28906 4.28516 7.74287 4.28516 12.0033C4.28516 16.2638 7.73896 19.7176 11.9994 19.7176Z"
      fill="#007AFF"
    />
    <path
      d="M15.856 9.85938L11.1417 14.5737L8.57031 12.0022"
      stroke="white"
      strokeWidth="1.54286"
      strokeLinecap="round"
    />
  </>
);

export default CheckFill;
